// Scene, sky, lights, camera and orbit controls.
import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { Sky } from 'three/addons/objects/Sky.js';
import { PI } from '../lib/math.js';
import { renderer } from './renderer.js';

export const scene = new THREE.Scene();
const pmrem = new THREE.PMREMGenerator(renderer);
// physical sky: one big dome for the background, one small copy rendered into the environment map
function makeSky(scale) {
  const sky = new Sky();
  sky.scale.setScalar(scale);
  sky.material.uniforms.skyGain = { value: 0.5 };
  sky.material.fragmentShader = sky.material.fragmentShader
    .replace('void main() {', 'uniform float skyGain;\nvoid main() {')
    .replace(
      'gl_FragColor = vec4( retColor, 1.0 );',
      'gl_FragColor = vec4( retColor * skyGain, 1.0 );',
    );
  return sky;
}
export const sky = makeSky(1800),
  envSky = makeSky(50),
  envScene = new THREE.Scene();
envScene.add(envSky);
scene.add(sky);
export const sunDir = new THREE.Vector3();
export function setSky(elev, az, gain, turbidity) {
  sunDir.setFromSphericalCoords(
    1,
    THREE.MathUtils.degToRad(90 - elev),
    THREE.MathUtils.degToRad(az),
  );
  for (const s of [sky, envSky]) {
    const u = s.material.uniforms;
    u.sunPosition.value.copy(sunDir);
    u.turbidity.value = turbidity;
    u.rayleigh.value = 3;
    u.mieCoefficient.value = 0.003;
    u.mieDirectionalG.value = 0.82;
    u.skyGain.value = gain;
  }
  const old = scene.environment;
  scene.environment = pmrem.fromScene(envScene, 0, 0.1, 100).texture;
  if (old) old.dispose();
}
setSky(32, 65, 0.42, 1.8);

export const cam = new THREE.PerspectiveCamera(32, innerWidth / innerHeight, 1, 2000);
cam.position.set(118, 82, 138);
export const controls = new OrbitControls(cam, renderer.domElement);
controls.target.set(0, 13, 0);
Object.assign(controls, {
  enableDamping: true,
  autoRotate: true,
  autoRotateSpeed: 0.5,
  minDistance: 30,
  maxDistance: 420,
  maxPolarAngle: PI * 0.47,
});
controls.addEventListener('start', () => (controls.autoRotate = false));

const skyCv = document.createElement('canvas');
skyCv.width = 2;
skyCv.height = 256;
const skyTex = new THREE.CanvasTexture(skyCv);
skyTex.colorSpace = THREE.SRGBColorSpace;
scene.background = skyTex;
// the physical sky only lights the scene; the visible backdrop is a controllable gradient
sky.visible = false;
export function paintSky(top, bottom) {
  const c = skyCv.getContext('2d'),
    g = c.createLinearGradient(0, 0, 0, 256);
  g.addColorStop(0, top);
  g.addColorStop(1, bottom);
  c.fillStyle = g;
  c.fillRect(0, 0, 2, 256);
  skyTex.needsUpdate = true;
}

scene.fog = new THREE.Fog(0xc6dcea, 140, 620);
export const hemi = new THREE.HemisphereLight(0xd8ecff, 0xcab88a, 0.95);
scene.add(hemi);
export const sun = new THREE.DirectionalLight(0xfff1d6, 2.6);
sun.position.copy(sunDir).multiplyScalar(130);
sun.castShadow = true;
sun.shadow.mapSize.setScalar(matchMedia('(pointer: coarse)').matches ? 2048 : 4096);
Object.assign(sun.shadow.camera, {
  left: -76,
  right: 76,
  top: 76,
  bottom: -76,
  near: 10,
  far: 400,
});
sun.shadow.bias = -0.0004;
sun.shadow.normalBias = 0.04;
scene.add(sun);
